import { render, staticRenderFns } from "./SortableTh.vue?vue&type=template&id=62d7825a&scoped=true"
import script from "./SortableTh.ts?vue&type=script&lang=ts&external"
export * from "./SortableTh.ts?vue&type=script&lang=ts&external"
import style0 from "./SortableTh.scss?vue&type=style&index=0&id=62d7825a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d7825a",
  null
  
)

export default component.exports